module.exports = __webpack_public_path__ + "static/media/testimonial_nur_laela.294b8716.png";